<tran-ui-content-section>
    <div class="pt-20 pb-[104px]">
        <h2 class="text-hero-l2 pb-16">
            <span class="font-bold">{{ 'home.dates-and-deadlines.title' | translate }}</span>
        </h2>

        @if (loading()) {
            <tran-customer-home-dates-and-deadlines-skeleton />
        } @else {
            <tran-pill-table rowClasses="font-bold">
                <tran-pill-header-row>
                    @for (header of headers; let headerIndex = $index; track headerIndex) {
                        <tran-pill-header-cell>
                            <div>
                                <span class="break-words">
                                    {{ header.title | translate }}
                                </span>
                                @if (header.helpText) {
                                    <tran-help [title]="header.helpTitle!" [content]="header.helpText" />
                                }
                            </div>
                        </tran-pill-header-cell>
                    }
                </tran-pill-header-row>

                @for (meeting of meetings(); track meeting.id; let meetingIndex = $index) {
                    <div [class]="meetingIndex !== 0 ? 'mt-8' : ''">
                        @for (deadline of meeting.deadlines; track deadline.id; let deadlineIndex = $index) {
                            @if (
                                meetingIndex === 0 &&
                                deadlineIndex === 0 &&
                                deadline.submitDeadline &&
                                deadline.preAwardDeadline
                            ) {
                                <tran-pill-header-row>
                                    {{ 'home.dates-and-deadlines.block-header1' | translate }}
                                </tran-pill-header-row>
                                <tran-pill-row class="mb-4">
                                    <tran-pill-cell bgColor="bg-data-turquoise-1" textColor="text-deep-blue-900">
                                        {{ deadline.submitDeadline | date: 'dd.MM.yyyy' }}
                                    </tran-pill-cell>
                                    <tran-pill-cell bgColor="bg-data-turquoise-3">
                                        {{ deadline.preAwardDeadline | date: 'dd.MM.yyyy' }}
                                    </tran-pill-cell>
                                    <tran-pill-cell bgColor="bg-data-turquoise-4">
                                        {{ meeting.startDate | date: 'dd.MM.yyyy' }}
                                    </tran-pill-cell>
                                </tran-pill-row>
                            } @else {
                                <tran-pill-row class="mb-1">
                                    <tran-pill-cell
                                        bgColor="bg-deep-blue-725"
                                        [disabled]="!deadline.submitDeadline && !deadline.preAwardDeadline"
                                    >
                                        {{ deadline.submitDeadline | date: 'dd.MM.yyyy' }}
                                    </tran-pill-cell>
                                    <tran-pill-cell
                                        bgColor="bg-deep-blue-750"
                                        [disabled]="!deadline.submitDeadline && !deadline.preAwardDeadline"
                                    >
                                        {{ deadline.preAwardDeadline | date: 'dd.MM.yyyy' }}
                                    </tran-pill-cell>
                                    <tran-pill-cell
                                        bgColor="bg-deep-blue-800"
                                        [disabled]="!deadline.submitDeadline && !deadline.preAwardDeadline"
                                    >
                                        {{ meeting.startDate | date: 'dd.MM.yyyy' }}
                                    </tran-pill-cell>
                                </tran-pill-row>
                            }
                        }
                    </div>
                }
            </tran-pill-table>
        }
    </div>
</tran-ui-content-section>
